import { signal, effect } from '@preact/signals';
import { secureStorage } from '../storage/secureStorage.js';

const STORAGE_KEY = '_aj1';

function load(): number {
  if (typeof localStorage === 'undefined') return 0;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return 0;
    const parsed = JSON.parse(raw);
    return typeof parsed === 'number' ? parsed : 0;
  } catch {
    return 0;
  }
}

export const atlasJumps = signal<number>(load());

if (typeof window !== 'undefined') {
  effect(() => {
    void secureStorage.setItem(STORAGE_KEY, JSON.stringify(atlasJumps.value));
  });
}

export function recordAtlasJump(): void {
  atlasJumps.value = atlasJumps.peek() + 1;
}
